var _Line, _Polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Line, Polygon } from "react-native-svg";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-send"
  }, props), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 22,
    y1: 2,
    x2: 11,
    y2: 13
  })), _Polygon || (_Polygon = /*#__PURE__*/React.createElement(Polygon, {
    points: "22 2 15 22 11 13 2 9 22 2"
  })));
};
export default SvgSend;